// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__F_sNx","overlay":"Modal_overlay__vNJ6v","opacity-animation":"Modal_opacity-animation__GGU77"};